"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Strings = require("@phg/stilo-utils/Strings");

var _ThemeProvider = require("../../theme/ThemeProvider");

var _style = _interopRequireDefault(require("./style"));

var _Entry = _interopRequireDefault(require("./components/Entry"));

var useStyles = (0, _ThemeProvider.createUseStyles)(_style["default"]);
/**
 * The basic button component
 */

var Indicator = function Indicator(_ref) {
  var id = _ref.id,
      className = _ref.className,
      children = _ref.children,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["id", "className", "children"]);
  var classes = useStyles();
  var childrenList = React.Children.toArray(children);
  var spacing = 100 / (childrenList.length * 2);
  var activeIndex = childrenList.findIndex(function (child) {
    if (React.isValidElement(child)) {
      return !!child.props.active;
    }
  });

  var isChildEntryActive = function isChildEntryActive(child) {
    return React.isValidElement(child) && !!child.props.active;
  };

  return /*#__PURE__*/React.createElement("div", (0, _extends2["default"])({}, rest, {
    id: id,
    className: (0, _classnames["default"])(classes.Indicator, className)
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      marginLeft: "".concat(spacing, "%"),
      marginRight: "".concat(spacing, "%")
    },
    className: "bar-wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pct-complete",
    style: {
      width: "".concat(activeIndex < 0 ? 0 : 100 * activeIndex / (childrenList.length - 1), "%")
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "dots"
  }, childrenList.map(function (child, ind) {
    return /*#__PURE__*/React.createElement("div", {
      key: ind,
      id: (0, _Strings.suffixIfSubject)(id, "-step-".concat(ind)),
      className: (0, _classnames["default"])('dot', isChildEntryActive(child) && 'active' || // mark as active if it has the prop
      (activeIndex < 0 || ind > activeIndex) && 'incomplete' // else mark if it's after the activeIndex
      )
    });
  }))), /*#__PURE__*/React.createElement("div", {
    className: "items-wrap"
  }, childrenList.map(function (child, ind) {
    return /*#__PURE__*/React.createElement("div", {
      id: (0, _Strings.suffixIfSubject)(id, "-label-".concat(ind)),
      key: ind,
      className: "item"
    }, child);
  })));
};

Indicator.Entry = _Entry["default"];
var _default = Indicator;
exports["default"] = _default;
//# sourceMappingURL=index.js.map